import LocationService from '@/services/core/LocationService';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
  user: {},
  address: LocationService.getAddress(),
  location: LocationService.getLocation(),
  isCurrentLocation: LocationService.isCurrentLocation(),
  avatars: []
};

export default {
  state,
  mutations,
  actions,
  getters,
};
